import React from 'react'
import { Box, Text, Tooltip } from '@chakra-ui/react'

interface Props {
    help: string
}

export default function CopyTemplateMissingInfoBanner({ help }: Props) {
    return (
        <Tooltip label={help} fontSize="xs" placement="top" hasArrow>
            <Box
                w="full"
                bg="yellow.50"
                borderWidth={1}
                borderColor="yellow.200"
                color="yellow.900"
                rounded="lg"
                px={{ base: 3, md: 4 }}
                py={{ base: 3, md: 4 }}
            >
                <Text fontSize="sm" fontWeight="semibold">
                    {help}
                </Text>
            </Box>
        </Tooltip>
    )
}
